import { Badge, type BadgeTone } from '../../components';
import type { ExportStatus } from '../../types/api';

/**
 * Estados da exportação (SPEC-023 §11).
 *
 * Badge próprio, e não o `JobStatusBadge`: export não tem `PARTIAL` nem
 * `CANCELLED`. Reaproveitar acoplaria dois vocabulários que só por enquanto se
 * parecem.
 */
const STATUS: Record<ExportStatus, { label: string; tone: BadgeTone }> = {
  PENDING: { label: 'Na fila', tone: 'neutral' },
  RUNNING: { label: 'Gerando…', tone: 'info' },
  COMPLETED: { label: 'Pronto', tone: 'success' },
  FAILED: { label: 'Falhou', tone: 'danger' },
  EXPIRED: { label: 'Expirado', tone: 'warning' },
};

export function ExportStatusBadge({ status }: { status: ExportStatus }) {
  const { label, tone } = STATUS[status];
  return <Badge tone={tone}>{label}</Badge>;
}

export function exportStatusLabel(status: ExportStatus): string {
  return STATUS[status].label;
}
